import theme from 'src/theme';
import styled from 'styled-components';

export const UndoContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 0.5rem;

    svg {
        ${(props) => props.theme.clickableIcon};
    }
`;

export const StowagePlanItemWrapper = styled.div`
    display: grid;
    grid-template-columns: minmax(20px, 20px) minmax(200px, 1fr) minmax(32px, 32px);
    align-items: center;
    width: 100%;
`;

export const StowagePlanItemSubWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left; !important;
    padding-left: 10px;
`;

export const StowagePlanListGroup = styled.li`
    max-height: 600px;
    overflow-y: auto;
`;

export const StowagePlanListItemTitle = styled.div`
    flex: 1;
    font-weight: bold;
    width: 100%;
`;

export const StowagePlanListItemSubtitle = styled.div`
    flex: 1;
    width: 100%;
`;

export const ReportOptionWrapper = styled.div<{
    disabled?: boolean;
}>`
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    padding: 2px;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${theme.colors.background.hover.default};
    }
`;

export const ReportOptionCheckbox = styled.input<{
    disabled?: boolean;
}>`
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const ReportOptionIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    color: ${theme.colors.text.heading};

    .icon {
        margin: 0 4px 0 2px;
        font-size: 1rem;
    }
`;

export const ReportOptionDescriptionText = styled.span`
    color: ${theme.colors.text.blueLink};
    font-size: 12px;
    flex: 1;
`;

export const StowagePlanActionToolbar = styled.li`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 8px;
    list-style: none;
`;

export const StowagePlanActionButton = styled.button<{ isDanger?: boolean }>`
    background: none;
    border: 1px solid ${theme.colors.border.ccc};
    border-radius: 4px;
    color: ${({ isDanger }) => (isDanger ? theme.colors.status.errorRed : theme.colors.text.heading)};
    cursor: pointer;
    font-size: 11px;
    padding: 4px 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: inherit;
    font-weight: 500;
    transition: background 0.12s, border-color 0.12s;

    &:hover:not(:disabled) {
        background: ${({ isDanger }) => (isDanger ? 'rgb(255, 240, 240)' : 'rgb(244, 248, 252)')};
        border-color: ${({ isDanger }) => (isDanger ? theme.colors.status.errorRed : theme.colors.text.heading)};
    }

    &:disabled {
        opacity: 0.35;
        cursor: default;
    }

    svg {
        font-size: 11px;
    }
`;

export const StowagePlanListItemRow = styled.span<{ $isSelected?: boolean }>`
    ${({ $isSelected }) =>
        $isSelected &&
        `
        background: rgba(0, 68, 126, 0.08) !important;
        border-left: 3px solid rgb(0, 68, 126);
    `}
`;
